import { useSelector } from "react-redux"
import { selectSearch } from "../../store/router/selectors"

export const useNotificationExists = () => {
    const search = useSelector(selectSearch)
    return !!search && search.indexOf("notificationId") !== -1
}
